import { render, staticRenderFns } from "./right_buttock_inner_hip.vue?vue&type=template&id=0a38b18d"
import script from "./right_buttock_inner_hip.vue?vue&type=script&lang=js"
export * from "./right_buttock_inner_hip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports